export const SYSTEM_CONTENT_TYPES = new Set<string>([
  'usuarios',
  'dispositivos',
  'screens',
  'forms',
  'menu_buttons'
]);

export const SYSTEM_CONTENT_TYPE_METRICS: ReadonlyMap<string, readonly string[]> = new Map([
  ['usuarios', ['registroUsuarios', 'gamificacion']],
  ['screens', ['app_startup', 'screen_view']],
  ['menu_buttons', ['menu_interaction']],
  ['forms', ['form_submission']]
]);

export function isSystemContentType(contentTypeId: string): boolean {
  return SYSTEM_CONTENT_TYPES.has(contentTypeId);
}

export interface FunnelStage {
  key: string;
  subtypes: readonly string[];
}

export const APP_STARTUP_FUNNEL_STAGES: readonly FunnelStage[] = [
  { key: 'app_start', subtypes: ['app_start'] },
  { key: 'permisos_entrada', subtypes: ['permisos_entrada'] },
  { key: 'permisos_completados', subtypes: ['permisos_completados_con_beacons', 'permisos_completados_sin_beacons'] },
  { key: 'menu_principal', subtypes: ['menu_principal'] }
];
